module.exports = __webpack_public_path__ + "static/media/Badge_SvgCommunityMaster.722dc902.svg";